export interface AdjacencySetting {
    _id: string,
    date: string,
    manufacturer: string,
    manufacturer_name: string,
    country:string,
    country_name:string,
    category:string,
    category_name:string,
    adjacency:any[]
}

export const adjacency_setting_default = {
    _id: "",
    date: "",
    manufacturer: "",
    manufacturer_name: "",
    country:"",
    country_name: "",
    category:"",
    category_name: "",
    adjacency:Array({regions:[], channels:[],outlet_classes:[],retailers:[],identifier_type:[],identifier_id:[],points:[0],type:[]})
}

export interface AdjacencySettingDetailFormData {
    _id: string;
    date: string;
    manufacturer: string;
    manufacturer_name: string,
    country:string;
    country_name:string;
    category:string;
    category_name:string;
    adjacency:Array<{regions:string[],channels:string[],outlet_classes:string[],retailers:string[],identifier_type:string[],identifier_id:any[][],points:number[],type:string[]}>
}

export interface AdjacencySettingUpdateProps {
    date: string;
    _id: string;
    manufacturer: string;
    country:string;
    category:string;
    adjacency:any[];
}

export const updateParams = (params: AdjacencySettingUpdateProps) => {
    return {
        _id: params._id,
        date: params.date,
        manufacturer: params.manufacturer,
        country:params.country,
        category:params.category,
        adjacency:params.adjacency
    };
}